module.exports = __webpack_public_path__ + "static/img/vouchers20010.52ace059.png";